import axios from 'axios';

import { IMeetingParticipantStatus } from '@/shared/model/meeting-participant-status.model';

const baseApiUrl = 'api/meeting-participant-statuses';

export default class MeetingParticipantStatusService {
  public find(id: number): Promise<IMeetingParticipantStatus> {
    return new Promise<IMeetingParticipantStatus>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IMeetingParticipantStatus): Promise<IMeetingParticipantStatus> {
    return new Promise<IMeetingParticipantStatus>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IMeetingParticipantStatus): Promise<IMeetingParticipantStatus> {
    return new Promise<IMeetingParticipantStatus>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
